import { useCallback } from "react";

import { useDispatch } from "react-redux";
import { configureSlices } from "utils/store/configureSlices";

import quoteRequestSliceV2 from "./quoteRequestSliceV2";

export const { useSlices, useSliceSelector: useQuoteRequestSelector } = configureSlices({
  quoteRequestSliceV2,
});

export const useResetState = (): (() => void) => {
  const dispatch = useDispatch();
  return useCallback(() => {
    dispatch(quoteRequestSliceV2.actions.resetState());
  }, [dispatch]);
};

export const useSetState = (): ((payload: Record<string, unknown>) => void) => {
  const dispatch = useDispatch();
  return useCallback(
    (payload: Record<string, unknown>) => {
      dispatch(quoteRequestSliceV2.actions.setState(payload));
    },
    [dispatch]
  );
};
